import { render, staticRenderFns } from "./refundList.vue?vue&type=template&id=96d065e8&scoped=true"
import script from "./refundList.vue?vue&type=script&lang=js"
export * from "./refundList.vue?vue&type=script&lang=js"
import style0 from "./refundList.vue?vue&type=style&index=0&id=96d065e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d065e8",
  null
  
)

export default component.exports